import { memo } from "react";

import { useTheme, Typography, ListItem, ListItemText, LinearProgress, Skeleton } from "@mui/material";
import { FormatDateOptions, useIntl } from "react-intl";

import TitledCard from "./templates/basic/TitledCard";
import { useDevice } from "../utils/DeviceProvider";

const ConfigInfo = memo(() => {
  const {
    device: { config, noConfig, syncLoading, template },
  } = useDevice();
  const { formatDate, formatMessage } = useIntl();

  const theme = useTheme();

  const dateFormatOptions: FormatDateOptions = {
    dateStyle: "short",
    timeStyle: "medium",
  };

  const configVersionLabel = config?.toolboxConfig?.configVersion ? config.toolboxConfig.configVersion : "-";

  return (
    <TitledCard title={formatMessage({ defaultMessage: "Configuration info" })} stretch={true}>
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <ListItem sx={{ paddingY: 0 }}>
          <ListItemText
            primary={
              <Typography variant="body1" component="span" color="secondary.main">
                {formatMessage({ defaultMessage: "Configured by" })}
              </Typography>
            }
            secondary={noConfig || !config?.id ? "-" : config ? config.modifierfullname || `(${config.modifiername})` : <Skeleton variant="text" />}
          />
        </ListItem>

        <ListItem sx={{ paddingY: 0 }}>
          <ListItemText
            primary={
              <Typography variant="body1" component="span" color="secondary.main">
                {formatMessage({ defaultMessage: "Configuration saved" })}
              </Typography>
            }
            secondary={
              noConfig || !config?.id || !config?.modifiedTs ? "-" : config ? formatDate(config.modifiedTs, dateFormatOptions) : <Skeleton variant="text" />
            }
          />
        </ListItem>

        <ListItem sx={{ paddingY: 0 }}>
          <ListItemText
            primary={
              <Typography
                variant="body1"
                component="span"
                color={
                  !(template?.template?.status?.configVersion && config?.toolboxConfig?.configVersion) ||
                  template?.template?.status?.configVersion === config?.toolboxConfig?.configVersion
                    ? theme.palette.secondary.main
                    : theme.palette.warning.main
                }
              >
                {formatMessage({ defaultMessage: "Last saved config version" })}
              </Typography>
            }
            secondary={noConfig ? "-" : config ? configVersionLabel : <Skeleton variant="text" />}
          />
        </ListItem>

        <ListItem sx={{ paddingY: 0 }}>
          <ListItemText
            primary={
              <Typography variant="body1" component="span" color="secondary.main">
                {formatMessage({ defaultMessage: "Notified about configuration" })}
              </Typography>
            }
            secondary={
              noConfig ? (
                "-"
              ) : config ? (
                syncLoading ? (
                  <LinearProgress color="inherit" sx={{ marginY: "8.01px" }} />
                ) : config.syncedTs ? (
                  formatDate(config.syncedTs, dateFormatOptions)
                ) : (
                  "-"
                )
              ) : (
                <Skeleton variant="text" />
              )
            }
            color="secondary"
          />
        </ListItem>
      </div>
    </TitledCard>
  );
});

export default ConfigInfo;
